import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, } from '@dixa/lib-shared-habla';
import { maxResultsCount } from 'app/views/layout/views/search/utils/results/maxResultsCount';
const getLabel = (counts, contactType) => {
    const count = counts[contactType];
    const cappedCount = count >= maxResultsCount ? `${maxResultsCount}+` : count.toString();
    switch (contactType) {
        case 'company':
            return `${cappedCount} ${count === 1 ? 'company' : 'companies'}`;
        case 'user':
        default:
            return `${cappedCount} ${count === 1 ? 'contact' : 'contacts'}`;
    }
};
const CONTACT_TYPES = ['user', 'company'];
/** Represents a dropdown component that is used to select a contact type */
export const ContactTypeDropdown = ({ counts, selected, onChange, }) => {
    return (_jsx(DropdownButton, Object.assign({ buttonProps: { variant: 'tertiary' }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(ButtonList, { children: CONTACT_TYPES.map((value) => (_jsx(ButtonList.Item, Object.assign({ isSelected: value === selected, onClick: () => {
                        toggleDropdown();
                        onChange(value);
                    }, isDisabled: counts[value] === 0 }, { children: getLabel(counts, value) }), value))) })) }) }, { children: getLabel(counts, selected) })));
};
